import React, { Component } from 'react';
import { connect } from 'react-redux';
import FetchHelper from '../../../helpers/fetchHelper';
import notification from '../../../components/notification';
import Modal from '../../../components/feedback/modal';
import {
  Row, Col, InputNumber, Input, Checkbox, Select, AutoComplete} from 'antd';
import Form from '../../../components/uielements/form';
const AutoCompleteOption = AutoComplete.Option;
const { Option } = Select;
const { TextArea } = Input;
class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type_documents: [],
      dataEmail: [],
    };
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData(){
    FetchHelper.httpRequest('GET', 'tiposDocumento').then(result => {
      if (result.error) {
        notification('error', result.error_msg);
      } else {
        this.setState({type_documents:result.data});
      }
    });
  }
  handleEmail = value => {
    let dataEmail;
    if (!value || value.indexOf('@') >= 0) {
      dataEmail = [];
    } else {
      dataEmail = ['gmail.com', 'hotmail.com', 'outlook.com', 'outlook.com.ar', 'yahoo.com.ar', 'yahoo.com'].map(
        domain => `${value}@${domain}`
      );
    }
    this.setState({ dataEmail });
  };

  render() {
    const { visible, toggleModal, confirmLoadingTitular, disabled } = this.props;
    const { type_documents, dataEmail } = this.state;
    const { getFieldDecorator } = this.props.form;
    const children = dataEmail.map(email => {
      return <AutoCompleteOption key={email}>{email}</AutoCompleteOption>;
    });
    return (
      <Modal
          maskClosable={false}
          title="Agregar nuevo usuario"
          visible={visible}
          onOk={toggleModal.bind(this, true)}
          onCancel={toggleModal.bind(this, false)}
          okButtonProps={{ disabled: disabled ? disabled: false }}
          confirmLoading={confirmLoadingTitular}
          okText="Agregar usuario"
          cancelText="Cancelar"
        >
        <Form>
          <Row gutter={8} justify="center">
            <Row gutter={8} justify="center">
              <Col md={12} sm={12} xs={24}>
                <Form.Item label="Nombre" style={{marginBottom:0}}>
                  {getFieldDecorator('nombre', {
                    rules: [
                      {
                        required: true,
                        message: 'Ingresa un nombre',
                      }
                    ],
                  })(<Input placeholder='* Nombre' maxLength={30}/>)}
                </Form.Item>
              </Col>
              <Col md={12} sm={12} xs={24}>
                <Form.Item label="Apellido" style={{marginBottom:0}}>
                  {getFieldDecorator('apellido', {
                    rules: [
                      {
                        required: true,
                        message: 'Ingresa un apellido'
                      }
                    ]
                  })(<Input placeholder='* Apellido' maxLength={30}/>)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8} justify="center">
              <Col md={12} sm={12} xs={24}>
                <Form.Item label="Tipo de Dcto." style={{marginBottom:0}}>
                {
                  getFieldDecorator('codigoDocumento', {
                  rules: [
                    {
                      required: true,
                      message: 'Seleccione un tipo de documento'
                    }
                  ],
                  initialValue: 'DNI',
                  })(<Select placeholder="Tipo de documento" notFoundContent="No se encontraron">
                      {
                        type_documents.length > 0 ?
                          type_documents.map((item) =>
                          <Option key={item.codigoDocumento} value={item.codigoDocumento}>{item.descripcion}</Option>
                          )
                        :
                        null
                      }
                    </Select>)
                }
                </Form.Item>
              </Col>
              <Col md={12} sm={12} xs={24}>
                <Form.Item label="Nº Documento" style={{marginBottom:0}}>
                  {getFieldDecorator('nroDocumento', {
                    rules: [
                      {
                        required: true,
                        message: 'Ingresa un nro. Documento'
                      }
                    ]
                  })(<InputNumber  style={{ width: '100%' }} placeholder='* Nro. Documento' min={0} max={99999999999}/>)}
                </Form.Item>
              </Col>
            </Row>
          <Row gutter={8} justify="center">
            <Col md={12} sm={12} xs={24}>
              <Form.Item label="Telefono" style={{marginBottom:0}}>
                {getFieldDecorator('telefono', {
                  rules: [
                    {
                      required: false,
                      message: 'Ingresa un telefono'
                    }
                  ]
                })(<Input placeholder='Telefono' maxLength={40}/>)}
              </Form.Item>
            </Col>
            <Col md={12} sm={12} xs={24}>
              <Form.Item label="Email" style={{marginBottom:0}}>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      required: false,
                      message: 'Ingresa un email'
                    },
                    {
                      type: 'email',
                      message: 'Ingresa un email valido',
                    },
                  ]
                })(<AutoComplete
                  onChange={this.handleEmail}
                  placeholder="Email"
                >
                  {children}
                </AutoComplete>)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8} justify="center">
              <Col xs={24}>
                <Form.Item  style={{ marginBottom: 0 }}>
                  {getFieldDecorator('sendNotification', {
                    initialValue: true,
                  })((<Checkbox defaultChecked={true}>Enviar email de notificación</Checkbox>))}
                </Form.Item>
              </Col>
            <Col xs={24}>
              <Form.Item style={{marginBottom:0}}>
                {getFieldDecorator('descriptionModify')
                (<TextArea row={4} placeholder='Ingresa el motivo de la modificación' maxLength={1000}/>)}
              </Form.Item>
            </Col>
          </Row>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(
  state => ({
    ...state.Client,
  }),
)(Client);
